import React from "react";
import { Card, Col, Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ActionType, IProduct, ProductsStrings } from "../../../../../business";
import "../../assets/css/product-list.css";

interface IProductList {
    data: Array<IProduct>;
    handleShowModal: (product: IProduct, action: ActionType) => void;
}

export const ProductList: React.FC<IProductList> = ({ data, handleShowModal }) => {
    const navigate = useNavigate();
    const { t } = useTranslation('product');
    const strings = ProductsStrings["PTBR"].products.type;
    const formatCurrency = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
    });
    return data.map((item) => (
        <Col key={item.id} xs={12} sm={6} md={4} lg={3} xl={3} xxl={2} style={{ marginBottom: "20px" }}>
            <Card>
                <Card.Img
                    src={item.image}
                    alt={item.part_name}
                    className={"cursor-link"}
                />
                <Card.Body>
                    <Card.Text>
                        <p className="product-name cursor-link text-capitalize">
                            {item.part_name}
                        </p>
                        {item.is_new ? strings.new : strings.used}
                    </Card.Text>
                    <Card.Title
                        style={{ marginTop: -10 }}
                        className={"justify-start-end"}
                    >
                        <p>{formatCurrency.format(item.price)}</p>

                        <Dropdown>
                            <Dropdown.Toggle variant="outline-dark" id="dropdown-basic">
                                {t('options')}
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item href="#" onClick={() => handleShowModal(item, ActionType.STOCK)}>{t('stock')}</Dropdown.Item>
                                <Dropdown.Item
                                    href="#"
                                    onClick={() => { navigate("/adm/productUpdate", { state: { productId: item.id } }) }}>
                                    {t('edit')}
                                </Dropdown.Item>
                                <Dropdown.Divider />
                                <Dropdown.Item href="#" onClick={() => handleShowModal(item, ActionType.DELETE)}>{t('delete')}</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </Card.Title>
                </Card.Body>
            </Card>
        </Col>
    ));
};
